import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import AdminNavbar from './AdminNavbar';

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  console.log('AdminRoute - user:', user);
  console.log('AdminRoute - loading:', loading);
  console.log('AdminRoute - token:', localStorage.getItem('token'));

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner"></div>
        <p>Cargando panel de administración...</p>
      </div>
    );
  }

  if (!user || (user.rol !== 'admin' && user.rol !== 'superadmin')) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-layout">
      <AdminNavbar />
      <div className="admin-content">
        {children}
      </div>
    </div>
  );
};

export default AdminRoute;